import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { useCallback } from 'react'

import { AiAnalystPage } from '@/components/AiAnalyst/AiAnalystPage'
import {
  aiAnalystSearchSchema,
  withoutAiAnalystSearchDefaults,
  type AiAnalystSearch,
} from '@/components/AiAnalyst/aiAnalystSearch'
import { inPageSearch, type SearchChangeOptions } from '@/lib/searchNavigation'

/** Wiring only. The schema lives beside the page in `aiAnalystSearch.ts`. */
export const Route = createFileRoute('/_app/ai-analyst/')({
  validateSearch: aiAnalystSearchSchema,
  component: AiAnalystRoute,
})

function AiAnalystRoute() {
  const search = Route.useSearch()
  const navigate = useNavigate({ from: Route.fullPath })

  const onSearchChange = useCallback(
    (next: Partial<AiAnalystSearch>, options?: SearchChangeOptions) =>
      void navigate(inPageSearch(withoutAiAnalystSearchDefaults, next, options)),
    [navigate],
  )

  return (
    <AiAnalystPage
      search={search}
      onSearchChange={onSearchChange}
      // A conversation is a different thing: push, so Back returns here.
      onOpenConversation={(conversationId) =>
        void navigate({
          to: '/ai-analyst/c/$conversationId',
          params: { conversationId },
          search: ({ topic: _topic, ...history }) => history,
        })
      }
      onNewChat={() => void navigate({ to: '/ai-analyst' })}
    />
  )
}
